import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import DOMPurify from 'dompurify';
import { getEnvConfigCssSelector } from 'util/applicationConfig';

const STYLE_SHEET_ID = 'casetivity-custom-css';

const updateCustomStyleSheet = (dangerousCss: string) => {
    const sheetToBeRemoved = document.getElementById(STYLE_SHEET_ID);
    if (sheetToBeRemoved) {
        const sheetParent = sheetToBeRemoved.parentNode;
        if (sheetParent) {
            sheetParent.removeChild(sheetToBeRemoved);
        }
    }
    const sheet = document.createElement('style');
    sheet.id = STYLE_SHEET_ID;
    const sanitizedCss = DOMPurify.sanitize('<style>' + dangerousCss + '</style>', { WHOLE_DOCUMENT: true }).slice(
        '<html><head><style>'.length,
        '</style></head><body></body></html>'.length * -1,
    );
    sheet.innerHTML = sanitizedCss;
    document.body.appendChild(sheet);
};
const WithEnvConfigGlobalStylesheet = prop => {
    const css = useSelector(getEnvConfigCssSelector);
    useEffect(() => {
        updateCustomStyleSheet(css);
    }, [css]);
    return null;
};
export default WithEnvConfigGlobalStylesheet;
